import { Link } from 'react-router-dom';

interface ClusterCard {
  title: string;
  description: string;
  to: string;
}

const cards: ClusterCard[] = [
  {
    title: 'Тренинг по лидерству',
    description: 'Как влиять на команду, формировать доверие и задавать направление развития.',
    to: '/menedzhment-i-liderstvo/trening-po-liderstvu',
  },
  {
    title: 'Делегирование и постановка задач',
    description: 'Как передавать ответственность сотрудникам и управлять результатом без микроменеджмента.',
    to: '/menedzhment-i-liderstvo/delegirovanie-i-postanovka-zadach',
  },
  {
    title: 'Обратная связь и сложные разговоры',
    description: 'Как давать обратную связь, которая меняет поведение, и проводить сложные разговоры.',
    to: '/menedzhment-i-liderstvo/obratnaya-svyaz-i-slozhnye-razgovory',
  },
  {
    title: 'Мотивация и управление командой',
    description: 'Как понимать мотивацию сотрудников и создавать условия для вовлечённости.',
    to: '/menedzhment-i-liderstvo/motivatsiya-i-upravlenie-komandoy',
  },
  {
    title: 'Управление конфликтами',
    description: 'Как разбирать конфликты в команде и переводить разногласия в рабочие решения.',
    to: '/menedzhment-i-liderstvo/trening-po-upravleniyu-konfliktami',
  },
  {
    title: 'Управленческие переговоры',
    description: 'Как руководителю договариваться с сотрудниками, коллегами, собственниками и руководством.',
    to: '/menedzhment-i-liderstvo/upravlencheskie-peregovory',
  },
  {
    title: 'Руководитель в переговорах',
    description: 'Как руководителю влиять, договариваться и отстаивать интересы бизнеса.',
    to: '/menedzhment-i-liderstvo/rukovoditel-v-peregovorah',
  },
  {
    title: 'Управление изменениями',
    description: 'Как внедрять новые процессы и правила, работая с сопротивлением сотрудников.',
    to: '/menedzhment-i-liderstvo/upravlenie-izmeneniyami',
  },
  {
    title: 'Тренинг для руководителей',
    description: 'Комплексная программа развития управленческих компетенций для руководителей всех уровней.',
    to: '/enciklopediya-korporativnogo-obucheniya/trening-dlya-rukovoditeley',
  },
  {
    title: 'Наставничество и развитие сотрудников',
    description: 'Как передавать опыт, развивать самостоятельность команды и формировать кадровый резерв.',
    to: '/menedzhment-i-liderstvo/nastavnichestvo-i-razvitie-sotrudnikov',
  },
];

export default function ClusterLinksSection() {
  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          Менеджмент и лидерство: другие направления развития
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center max-w-3xl mx-auto mb-12 leading-relaxed">
          Управленческие компетенции состоят из нескольких взаимосвязанных направлений. Чтобы развить их системно, важно опираться на специализированные программы кластера «Менеджмент и лидерство».
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {cards.map((card) => (
            <div
              key={card.title}
              className="bg-gray-50 rounded-xl border border-gray-200 hover:border-teal-300 transition-all p-5 md:p-6 flex flex-col"
            >
              <h3 className="text-base font-bold text-gray-900 mb-2">{card.title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed mb-4 flex-grow">{card.description}</p>
              <Link
                to={card.to}
                className="inline-flex items-center gap-1.5 text-sm font-semibold text-teal-600 hover:text-teal-700 transition-colors cursor-pointer whitespace-nowrap mt-auto"
              >
                Подробнее
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}